import { cn, formatDuration } from '@workspace/ui/lib/utils'
import { Clock } from 'lucide-react'
import type * as React from 'react'

export interface SessionTimerProps extends React.HTMLAttributes<HTMLDivElement> {
  seconds: number
  showIcon?: boolean
}

function SessionTimer({ seconds, showIcon = false, className, ...props }: SessionTimerProps) {
  return (
    <div
      className={cn('inline-flex items-center gap-1.5 text-sm text-muted-foreground', className)}
      role="timer"
      aria-label={`Duration: ${formatDuration(seconds)}`}
      {...props}
    >
      {showIcon && <Clock className="size-4" />}
      <span className="font-medium tabular-nums">{formatDuration(seconds)}</span>
    </div>
  )
}

export { SessionTimer }
